import type { z } from 'zod/v3';
import type { governedFactHandoffSchema } from './governed-fact-handoff.schema';

export const GOVERNED_FACT_HANDOFF_VERSION = 'helix.governed-fact-handoff.v2' as const;
export { GOVERNED_LOOKUP_FAILURES, type GovernedLookupFailure } from '@helix/lib/ask-helix/contracts/provider-failure';

export type GovernedFactHandoff = z.infer<typeof governedFactHandoffSchema>;
export const GOVERNED_FINAL_LIMITS = {
  blockBytes: 4096, totalBytes: 16384, tokens: 120,
  receivedBytes: 32768, depth: 8,
} as const;
export const GOVERNED_FRACTION_INSTRUCTION =
  'Express fractional shares and multiplicative changes through the token of an executed '
  + 'governed query or derive result. Do not encode their numeric magnitude in prose words '
  + 'or verb inflections. Write the explanation around that token; '
  + 'never calculate the change yourself.';
export interface GovernedProviderOutcome {
  readonly kind: 'completed' | 'truncated' | 'interrupted' | 'refused';
  readonly reasonCode?: string;
  readonly capability: 'json_schema' | 'json_object';
}
